var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25001 12.0768C8.25001 12.4911 8.58579 12.8268 9.00001 12.8268C9.41422 12.8268 9.75001 12.4911 9.75001 12.0768H8.25001ZM9.75001 8.99993C9.75001 8.58571 9.41422 8.24993 9.00001 8.24993C8.58579 8.24993 8.25001 8.58571 8.25001 8.99993H9.75001ZM9.00001 5.173C8.58579 5.173 8.25001 5.50879 8.25001 5.923C8.25001 6.33722 8.58579 6.673 9.00001 6.673V5.173ZM9.00984 6.673C9.42405 6.673 9.75984 6.33722 9.75984 5.923C9.75984 5.50879 9.42405 5.173 9.00984 5.173V6.673ZM15.9422 8.99992C15.9422 12.8341 12.8341 15.9422 8.99992 15.9422V17.4422C13.6625 17.4422 17.4422 13.6625 17.4422 8.99992H15.9422ZM8.99992 15.9422C5.16579 15.9422 2.05762 12.8341 2.05762 8.99992H0.557617C0.557617 13.6625 4.33737 17.4422 8.99992 17.4422V15.9422ZM2.05762 8.99992C2.05762 5.16579 5.16579 2.05762 8.99992 2.05762V0.557617C4.33737 0.557617 0.557617 4.33737 0.557617 8.99992H2.05762ZM8.99992 2.05762C12.8341 2.05762 15.9422 5.16579 15.9422 8.99992H17.4422C17.4422 4.33737 13.6625 0.557617 8.99992 0.557617V2.05762ZM9.75001 12.0768V8.99993H8.25001V12.0768H9.75001ZM9.00001 6.673H9.00984V5.173H9.00001V6.673Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.0d7529fd690cd5f132b96b4cec22f68a.svg";
export { ForwardRef as ReactComponent };